import { mergeProps, Tooltip, useRender } from '@base-ui/react';
import { useCallback } from 'react';

import { useCraftLocalStorage } from '~/hooks/useCraftLocalStorage';
import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';
import { clsx } from '~/styles/utils';

import { NavigationContext } from './Navigation.context';
import { rootCollapsedStyle, rootStyle } from './Navigation.css';

type Props = useRender.ComponentProps<'div'>;

export const NavigationRoot = ({ render, ...delegated }: Props) => {
  const [sidebarState, setSidebarState] = useCraftLocalStorage('sidebar');
  const isMobile = useMediaQuery(breakpoints.small);

  const isCollapsed = sidebarState === 'collapsed';
  const showLabels = isMobile || !isCollapsed;

  const toggleCollapsed = useCallback(() => {
    setSidebarState(isCollapsed ? 'expanded' : 'collapsed');
  }, [isCollapsed, setSidebarState]);

  const element = useRender({
    defaultTagName: 'div',
    render,
    props: mergeProps<'div'>(
      {
        className: clsx(rootStyle, isCollapsed && rootCollapsedStyle),
      },
      delegated,
    ),
  });

  return (
    <NavigationContext value={{ toggleCollapsed, isCollapsed, showLabels }}>
      <Tooltip.Provider delay={500}>{element}</Tooltip.Provider>
    </NavigationContext>
  );
};
